import { NIcon } from "naive-ui";
import { h } from "vue";
import { format, parse, parseISO, isValid } from "date-fns";

export function renderIcon(icon) {
  return () => h(NIcon, null, { default: () => h(icon) });
}

export function getCssVar(name) {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
}

export function renderNullable(value) {
  return value != null && value !== "" ? value : "-";
}

export function getLabelByValue(value, options) {
  return options.find((option) => option.value === value)?.label ?? "";
}

export function getValueByLabel(label, options) {
  return options.find((option) => option.label === label)?.value ?? "";
}

export function showComingSoonAlert(text) {
  alert(text ?? "서비스 준비중입니다.");
}

export function formatTwoDigits(num) {
  if (num < 10) {
    return String(num).padStart(2, "0");
  }
  return String(num);
}

export function formatExamTimeText(startTime, endTime) {
  let startTimeText = "진행 시 표기";
  let endTimeText = "종료 시 표기";
  let startTimeFormat = toDateSafe(startTime);
  let endTimeFormat = toDateSafe(endTime);
  if (startTimeFormat) {
    startTimeText = format(startTimeFormat, "yyyy.MM.dd HH:mm");
  }
  if (endTimeFormat) {
    endTimeText = format(endTimeFormat, "yyyy.MM.dd HH:mm");
  }
  return `${startTimeText} ~ ${endTimeText}`;
}

export function handleExamStatusChipOption(status) {
  switch (status) {
    case "unable":
      return { color: "gray", variant: "outlined" };
    case "waiting":
      return { color: "gray", variant: "outlined" };
    case "running":
      return { color: "blue", variant: "ghost" };
    case "end":
      return { color: "gray", variant: "ghost" };
    default:
      return { color: "gray", variant: "outlined" };
  }
}
export function handleMonitoringStatusChipOption(status) {
  switch (status) {
    case "미응시":
      return { color: "gray", variant: "outlined" };
    case "안내문":
    case "응시정책 동의":
    case "시험 시작 대기":
    case "답안 제출":
      return { color: "blue", variant: "outlined" };
    case "시험 중단":
      return { color: "red", variant: "ghost" };
    case "시험중단":
      return { color: "red", variant: "ghost" };
    case "시험 종료":
      return { color: "gray", variant: "ghost" };
    case "시험종료":
      return { color: "gray", variant: "ghost" };
    default:
      return { color: "blue", variant: "ghost" };
  }
}

export function handleNoticeCategoryChipColor(category) {
  switch (category) {
    case "notice":
      return "blue";
    case "inspection":
      return "yellow";
    case "all":
      return "gray";
    default:
      return "blue";
  }
}


// 문자열 → ISO 보정
const normalizeToISO = (s) => {
  if (!s) return null;
  s = String(s).trim();
  // yyyy.MM.dd HH:mm(:ss) → yyyy-MM-ddTHH:mm(:ss)
  if (/^\d{4}[./]\d{2}[./]\d{2}\s\d{2}:\d{2}(:\d{2})?$/.test(s)) {
    return s.replace(/[./]/g, "-").replace(" ", "T");
  }
  if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}(:\d{2})?$/.test(s)) return s.replace(" ", "T");
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s}T00:00:00`;
  if (/^\d{4}[./]\d{2}[./]\d{2}$/.test(s)) return s.replace(/[./]/g, "-") + "T00:00:00";
  return s;
};


export const toDateSafe = (input) => {
  if (!input) return null;
  // 브라우저 기본 Date 파싱 우선 적용
  const d = new Date(input);
  if (isValid(d)) return d;
  if (input instanceof Date) return isValid(input) ? input : null;
  if (typeof input === "number") {
    const dNum = new Date(input);
    return isValid(dNum) ? dNum : null;
  }
  const iso = normalizeToISO(input);
  if (!iso) return null;

  const d1 = parseISO(iso);
  if (isValid(d1)) return d1;

  for (const f of [
    "yyyy-MM-dd'T'HH:mm:ss",
    "yyyy-MM-dd HH:mm:ss",
    "yyyy-MM-dd",
    "yyyy.MM.dd",
    "yyyy/MM/dd",
  ]) {
    const d = parse(iso, f, new Date());
    if (isValid(d)) return d;
  }
  return null;
};